<template>
  <div class="home-main-right">
    <div class="recruit-student-menus" v-if="!currentMenu">
      <div class="recruit-student-professional-directory">
        <div class="common-title theme-primary-text-color">
          <div class="line theme-primary-background-color"></div>
          <span class="text">招生专业目录</span>
        </div>
        <div class="professional-directory-list">
          <div class="professional-directory-item"
               @click="handleToProfessionalDirectory(item.path)"
               v-for="(item, index) in professionalDirectoryMenus"
               :key="index">
            {{item.name}}
          </div>
        </div>
      </div>
      <div class="recruit-student-project">
        <div class="common-title theme-primary-text-color">
          <div class="line theme-primary-background-color"></div>
          <span class="text">招生项目</span>
        </div>
        <div class="project-list">
          <div class="project-item"
               v-for="(item, index) in projectMenus"
               :key="index">
            <div class="project-item-content" @click="currentMenuCode = item.code">
              <div class="project-item-icon theme-primary-text-color" v-html="getMenuIcon(item.code)" v-if="item && item.code && item.code !== 'apply'"></div>
              <div class="project-item-icon-adjust theme-primary-text-color" v-html="getMenuIcon(item.code)" v-else-if="item && item.code && item.code === 'apply'"></div>
              <div class="project-item-text theme-primary-text-color">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="recruit-student-sub-menus" v-else>
      <div class="back-home">
        <div class="back-home-btn" @click="currentMenuCode = ''">
          返回主页
        </div>
      </div>
      <div class="recruit-student-sub-menus-header">
        <div class="icon theme-primary-text-color" v-html="getMenuIcon(currentMenu.code)" v-if="currentMenu.code !== 'apply'"></div>
        <div class="project-item-icon-adjust theme-primary-text-color" v-html="getMenuIcon(currentMenu.code)" v-else-if="currentMenu && currentMenu.code && currentMenu.code === 'apply'"></div>
        <div class="text theme-primary-text-color">{{currentMenu.name}}</div>
      </div>
      <div class="recruit-student-sub-menus-list">
        <div class="recruit-student-sub-menus-item"
             v-for="(item, index) in currentMenu.links"
             :key="index">
          <div class="recruit-student-sub-menus-item-content"
               @click="handleToSubMenu(item.path)">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import support from '../../../mixins/support'
import {mapState} from 'vuex'

export default {
  name: 'HomeMainRight',
  mixins: [support],
  props: {
    menuCode: String
  },
  data () {
    return {
      // 为空则表示在首页
      currentMenuCode: '',
      // 招生专业目录菜单
      professionalDirectoryMenus: [],
      // 招生专业目录路由
      professionalDirectoryRoutes: [
        {
          code: 'master',
          path: 'directory/masterMainland'
        },
        {
          code: 'doctor',
          path: 'directory/doctorMainland'
        },
        {
          code: 'hongKongMaster',
          path: 'directory/masterGAT'
        },
        {
          code: 'hongKongDoctor',
          path: 'directory/doctorGAT'
        }
      ],
      // 招生项目菜单
      projectMenus: []
    }
  },
  computed: {
    ...mapState({
      authorizeObj: state => state.authorization.authorizeObj
    }),
    currentMenu () {
      return this.projectMenus.find(item => item.code === this.currentMenuCode) || null
    }
  },
  methods: {
    getMenuIcon (code) {
      switch (code) {
        case 'summerCamp':
          return '&#xed14;'
        case 'examExempted':
          return '&#xe638;'
        case 'master':
          return '&#xe6ef;'
        case 'preAdjust':
          return '&#xe60e;'
        case 'examDoctor':
          return '&#xe6a7;'
        case 'doctor':
        case 'unifiedDoctor':
          return '&#xe6ed;'
        case 'apply':
          return '&#xe6e7;'
        default:
          return ''
      }
    },
    handleToSubMenu (path) {
      if (this.authorizeObj) {
        if (path) {
          this.$router.push(path)
        }
      } else {
        this.$message.warning('请先登录！')
      }
    },
    handleToProfessionalDirectory (path) {
      if (path) {
        this.$router.push(path)
      } else {
        this.$message.warning('暂未发布，敬请期待！')
      }
    },
    getPublishedCatalogType () {
      this.$ajax({
        url: '/index/catalogMajor/publishedCatalogMajorType',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              let catalogType = response.data['catalogType']
              this.professionalDirectoryMenus = catalogType.map(item => {
                let route = this.professionalDirectoryRoutes.filter(route => route.code === item.code)[0]
                return {...item, ...route}
              })
            }
          }
        }
      })
    },
    getProjectModule () {
      this.$ajax({
        url: '/index/homeIndex/',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              let moduleList = response.data['modules'] || []
              this.projectMenus = moduleList
            }
          }
        }
      })
    }
  },
  created () {
    this.currentMenuCode = this.menuCode
  },
  mounted () {
    this.getPublishedCatalogType()
    this.getProjectModule()
  }
}
</script>

<style lang="scss">
.home-main-right {
  background-color: #fff;
  width: 66%;
  box-sizing: border-box;
  padding: 40px 15px;
  &>.recruit-student-menus {
    .common-title {
      font-size: 18px;
      height: 20px;
      line-height: 20px;
      padding-left: 10px;
      position: relative;
      margin-bottom: 60px;
      &>.line {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 3px;
      }
      &>.text {
        font-weight: bold;
      }
    }
    &>.recruit-student-professional-directory {
      overflow: hidden;
      &>.professional-directory-list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -60px;
        padding: 0 10px;
        &>.professional-directory-item {
          font-size: 13px;
          font-weight: bold;
          color: #040404;
          padding: 0 60px;
          margin-bottom: 60px;
          cursor: pointer;
        }
      }
    }
    &>.recruit-student-project {
      &>.project-list {
        display: flex;
        flex-wrap: wrap;
        margin-left: -10px;
        &>.project-item {
          width: 106px;
          margin-bottom: 30px;
          &>.project-item-content {
            cursor: pointer;
            &>.project-item-icon {
              text-align: center;
              font-family: iconfont;
              font-size: 70px;
              margin: 0 auto 34px;
            }
            &>.project-item-icon-adjust {
              text-align: center;
              font-family: iconfont-jcl;
              font-size: 70px;
              margin: 0 auto 34px;
            }
            &>.project-item-text {
              text-align: center;
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  &>.recruit-student-sub-menus {
    &>.back-home {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      &>.back-home-btn {
        padding-left: 20px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-weight: bold;
        color: #787878;
        position: relative;
        cursor: pointer;
        &::before {
          content: "\e60c";
          position: absolute;
          left: 0;
          top: 0;
          font-size: 16px;
          font-family: iconfont;
          height: 20px;
          width: 16px;
        }
      }
    }
    &>.recruit-student-sub-menus-header {
      display: flex;
      align-items: center;
      &>.icon {
        font-family: iconfont;
        font-size: 78px;
      }
      &>.project-item-icon-adjust {
        font-family: iconfont-jcl;
        font-size: 78px;
      }
      &>.text {
        margin-left: 25px;
        font-size: 22px;
        font-weight: bold;
        margin-top: -8px;
      }
    }
    &>.recruit-student-sub-menus-list {
      margin: 50px auto 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &>.recruit-student-sub-menus-item {
        padding: 0 10px;
        margin-bottom: 70px;
        &>.recruit-student-sub-menus-item-content {
          width: 228px;
          height: 38px;
          font-weight: bold;
          color: #676767;
          font-size: 12px;
          text-align: center;
          line-height: 38px;
          border: 1px solid #F3F2F2;
          box-shadow: 0px 0px 10px 0px rgba(171, 199, 227, 0.1), 0px 5px 10px 0px rgba(171, 199, 227, 0.3);
          border-radius: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
@media (max-width: 1260px) {
  .home-main-right {
    &>.recruit-student-sub-menus {
      &>.recruit-student-sub-menus-list {
        width: 580px;
        &>.recruit-student-sub-menus-item {
          margin-bottom: 35px;
          padding: 0 30px;
        }
      }
    }
  }
}

@media (max-width: 1052px) {
  .home-main-right {
    &>.recruit-student-menus {
      .common-title {
        margin-bottom: 24px;
      }
      &>.recruit-student-professional-directory {
        overflow: hidden;
        &>.professional-directory-list {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -60px;
          padding: 0 10px;
          &>.professional-directory-item {
            margin-bottom: 24px;
          }
        }
      }
      &>.recruit-student-project {
        margin-top: 20px;
        &>.project-list {
          &>.project-item {
            margin-bottom: 30px;
          }
        }
      }
    }
    &>.recruit-student-sub-menus {
      &>.recruit-student-sub-menus-list {
        width: 230px;
        &>.recruit-student-sub-menus-item {
          margin-bottom: 35px;
          padding: 0;
        }
      }
    }
  }
}

@media (max-width: 720px) {
  .home-main-right {
    &>.recruit-student-menus {
      &>.recruit-student-project {
        &>.project-list {
          &>.project-item {
            width: 86px;
            &>.project-item-content {
              &>.project-item-icon {
                font-size: 52px;
              }
              &>.project-item-icon-adjust {
                font-size: 52px;
              }
              &>.project-item-text {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 640px) {
  .home-main-right {
    width: 100%;
    margin-top: 15px;
    padding: 0;
    background-color: inherit;
    &>.recruit-student-menus {
      &>.recruit-student-professional-directory,
      &>.recruit-student-project{
        padding: 30px 15px 0;
        background-color: #fff;
      }
    }
    &>.recruit-student-sub-menus {
      padding: 30px 15px 0;
      background-color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homeIndex/HomeMainRight.vue